<template>
  <div class="ui-card-product overflow-hidden" v-if="product">
    <div
      v-if="product.ppm && product.ppm.flag"
      class="marketing-badge"
      :class="getBadgeClass(product.ppm.flag)"
    >
      <span>{{ getBadgeText(product.ppm.flag) }}</span>
    </div>
    <figure class="ui-card-product__figure">
      <img
        class="ui-card-product__img"
        :src="showImage(product.ppl.productproducer.image, product.ppl.image)"
        :alt="
          product.ppl.productproducer.translations[$i18n.locale].name +
          ' - ' +
          product.ppl.translations[$i18n.locale].name
        "
      />
    </figure>
    <div
      class="ui-card-product__company"
      v-if="product.ppl.productproducer.producer.role.name"
    >
      {{ product.ppl.productproducer.producer.role.name }}
    </div>
    <div
      class="ui-card-product__title"
      v-if="product.ppl.productproducer.translations[$i18n.locale].name"
    >
      {{ product.ppl.productproducer.translations[$i18n.locale].name }}
    </div>
    <div
      class="ui-card-product__subtitle"
      v-if="product.ppl.translations[$i18n.locale].name"
    >
      {{ product.ppl.translations[$i18n.locale].name }}
    </div>
    <div class="ui-card-product__footer">
      <div class="ui-card-product__price">
        <slot name="price" v-if="showPrice()"
          >{{ formatPrice(product.ppm.price) }} <sup>{{ currencySymbol }}</sup
          ><small v-if="showWeightUnit()">/ {{ weightUnit }}</small></slot
        >
      </div>
    </div>
  </div>
</template>

<script>
import currency from "currency.js";
import { formatPrice } from "../../../helpers/common";
import { mapGetters } from "vuex";

export default {
  name: "MarketProductCard",

  props: {
    product: {
      type: Object,
      required: true,
    },
    flags: {
      type: Array,
      required: false,
      default: () => [],
    },
  },

  methods: {
    onClick() {
      this.$emit("onClick", this.product.id);
    },
    showPrice() {
      return typeof this.product.ppm.price !== "undefined";
    },
    showPriceRange() {
      return typeof this.product.ppm.price === "undefined";
    },
    formatPrice(value) {
      return formatPrice(value).format();
    },
    showWeightUnit() {
      return false;
    },
    showImage(ppImage, pplImage) {
      let imgSrc = "";
      if (pplImage) {
        imgSrc = pplImage.image_sm;
      } else {
        if (ppImage) {
          imgSrc = ppImage.image_sm;
        } else {
          imgSrc = "/loonity/img/placeholder.png";
        }
      }
      return imgSrc;
    },
    marketingBadge(flagId) {
      const flag = this.flags.find((f) => f.value === flagId);
      return flag;
    },
    getBadgeText(flagId) {
      const emojis = {
        1: "⭐",
        2: "🔥",
        3: "✨",
        4: "⭐",
        5: "🔥",
        6: "🔥",
      };
      const emoji = emojis[flagId] || "";
      const flag = this.flags.find((f) => f.value === flagId);
      return flag ? `${emoji} ${flag.label}` : "";
    },
    getBadgeClass(flagId) {
      const classes = {
        1: "badge-specialty",
        2: "badge-offer",
        3: "badge-new",
        4: "badge-specialty-new",
        5: "badge-offer-new",
        6: "badge-specialty-offer",
      };
      return classes[flagId] || "";
    },
  },

  computed: {
    ...mapGetters("connections", ["currencySymbol"]),
  },
};
</script>
